module.exports = __webpack_public_path__ + "img/Logo_Gifi.d2eaf729.jpeg";